import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { TotemWidget } from '../totem-widget';

export class TotemWidgetWelcomeButton { 
    text:string
    color:string
    url?:string
    widget?:string
}

@Component({
    selector: 'app-totem-widget-welcome',
    templateUrl: './totem-widget-welcome.component.html',
    styleUrls: ['./totem-widget-welcome.component.scss'],
    standalone: false
})
export class TotemWidgetWelcomeComponent extends TotemWidget implements OnInit {

    constructor(public elementRef:ElementRef) {
        super(elementRef)
    }

    size:'lg' = 'lg'

    @Input() title:string
    @Input() text:string
    @Input() background:string
    @Input() image:string
    @Input() links:Array<{ url: string, text: string, color: string }>
    @Input() socials:{ [id:string]: { url: string, color: string } }


    ngOnInit(): void {
    }

    private _validColorClass = [
        'primary',
        'secondary',
        'success',
        'danger',
        'warning',
        'info',
        'light',
        'dark',
        'white'
    ]

    getBackgroundClass() {
        if(this._validColorClass.indexOf(this.background) != -1) return this.background
    }

    getBackgroundStyle() {
        if(this._validColorClass.indexOf(this.background) == -1) return this.background
    }

    onLinkClick(button:TotemWidgetWelcomeButton) {
        if(button.url) {
            window.open(button.url)
        }
        else if(button.widget) {
            this.requestFullScreen.emit({ widget: button.widget })
        }
    }

    onSocialClick(social:string) {
        window.open(this.socials[social].url)
    }
}
